import React, { Fragment } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Image, Transition as SemanticTransition } from 'util/ui'
import { SubHeader } from 'shared/components/ui/Typography'
import hubspotImgSrc from 'assets/onboarding/layout/hubspot.png'
import keenImgSrc from 'assets/onboarding/layout/keen.png'
import buySellImgSrc from 'assets/onboarding/layout/buysell.png'
import wagImgSrc from 'assets/onboarding/layout/wag.png'
import boomerangImgSrc from 'assets/onboarding/layout/boomerang.png'
import musuemhackImgSrc from 'assets/onboarding/layout/musuemhack.png'

import styles from './styles.less'

const testimonials = {
  AcceptInvitePage:
    'You’re joining 8,000+ companies around the world delivering amazing support with Groove.',
  SignupPage:
    'You’re joining 8,000+ companies around the world delivering amazing support with Groove.',
  CustomerInformationPage:
    'Whether you need the power of a help desk or the simplicity of a shared inbox, we’ve got you covered.',
  AddTeamMembersPage:
    'With Groove, you and your team can be up and running in under 30-minutes. No implementation plan or expensive training needed.',
  FacebookPageSelectionPage:
    'Every reply from Groove looks just like a typical email, tweet, or comment, allowing you to add your personal touch at scale.',
}

export default function OnboardingLayout({ children, page }) {
  const testimonial = testimonials[page]
  return (
    <div className={styles.container}>
      <TransitionGroup className={styles.leftColumn}>
        <CSSTransition
          key={`${page}-body-transition`}
          classNames="slide"
          timeout={500}
          unmountOnExit
        >
          <div className={styles.flex3Row}>
            <div className={styles.logo} />
            <div className={styles.body}>
              <div className={styles.flexFloatMid}>{children}</div>
            </div>
            <div className={styles.footer}>
              {page === 'SignupPage' && (
                <Fragment>
                  Already have an account? <a href="/login">Sign in</a>
                </Fragment>
              )}
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
      <div className={styles.rightColumn}>
        <div className={styles.body}>
          <SemanticTransition
            key={`onboarding-testimonial-${testimonial}`}
            animation="fade"
            duration={500}
            unmountOnHide
            transitionOnMount
            visible
          >
            <SubHeader as="h1" size="large" color="white" textAlign="center">
              {testimonial}
            </SubHeader>
          </SemanticTransition>

          <ul className={styles.companies}>
            <li>
              <Image src={hubspotImgSrc} title="Hubspot" />
            </li>
            <li>
              <Image src={keenImgSrc} title="Keen IO" />
            </li>
            <li>
              <Image src={buySellImgSrc} title="BuySellAds" />
            </li>
            <li>
              <Image src={wagImgSrc} title="Wag!" />
            </li>
            <li>
              <Image src={boomerangImgSrc} title="Boomerang Commerce" />
            </li>
            <li>
              <Image src={musuemhackImgSrc} title="MuseumHack" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
